const map = require('mn-utils/map');
const AdminCell = require('../../../TableHeadCell/AdminCell');
const {AdminTableRow} = require('../../../TableRow');
const MenuForItem = require('../../../Menu/ForItem');
const React = require('react');

module.exports = ({minWidth = 1100, cols, items, maxHeight, rowActions}) => {
  const defaultClassName = 'wmin180 fx1';
  const hasScroll = items.length * 70 > maxHeight;

  return (
    <>
      <div
        className="h345 mt24 rlv"
        style={{
          height: hasScroll
            ? maxHeight + 45
            : items.length * 70 + 45
        }}
      >
        <div className="ovxA abs s">
          <div className="w rlv bgE layoutRow aiStretch" style={{minWidth: `${minWidth}px`}}>
            {map(cols, (col = {}, id) => (
              <AdminCell
                key={id}
                className={col.className ? col.className : defaultClassName}
              >
                {col.title}
              </AdminCell>
            ))}
            { hasScroll && <AdminCell className="w8" /> }
          </div>
          <div
            className="abs sh st45 sb c0>.CircularProgress"
            style={{
              minWidth: `${minWidth}px`,
              height: hasScroll
                ? maxHeight
                : items.length
                  ? items.length * 70
                  : 70
            }}
          >
            {items.length
              ? map(items, (row = {}, rowId) => {
                return (
                  <AdminTableRow className="f12" key={rowId} index={rowId}>
                    {cols.map((col = {}, colId) => {
                      const val = col.key
                        ? row[col.key]
                        : col.handleCol
                          ? col.handleCol(row)
                          : '';

                      return (
                        <div key={colId} className={col.className ? col.className : defaultClassName}>
                          {val}
                        </div>
                      );
                    })}
                    {rowActions
                      ? (
                        <div className="abs sr8 st50% xY-50%">
                          <MenuForItem
                            items={rowActions(row)}
                          />
                        </div>
                      ) : false
                    }
                  </AdminTableRow>
                );
              }) : (
                <div className="h layoutRow jcC aiC f16 fw4">
                  No items
                </div>
              )
            }
          </div>
        </div>
      </div>
    </>
  );
};
